import { createSlice } from '@reduxjs/toolkit';

export const channelSlice = createSlice({
    name: 'channels',
    initialState: {
        channelData: {},
    },
    reducers: {
        fetchPricesStart: (state, { payload }) => {
            const { channelId } = payload;
            state.channelData[channelId] = {
                ...state.channelData[channelId],
                loading: true,
                error: null,
            };
        },
        updateChannelPrice: (state, { payload }) => {
            const { channelId, price } = payload;
            state.channelData[channelId] = {
                price,
                loading: false,
                error: null,
            };
        },
        fetchPricesError: (state, { payload }) => {
            const { channelId, error } = payload;
            state.channelData[channelId] = {
                ...state.channelData[channelId],
                loading: false,
                error,
            };
        },
        resetChannelData: (state) => {
            state.channelData = {};
        },
    },
});

export const {
    fetchPricesStart,
    updateChannelPrice,
    fetchPricesError,
    resetChannelData,
} = channelSlice.actions;

export const selectChannelPrices = (state) => state.channels.channelData;

export default channelSlice.reducer;
